export default {
    props: {
        additional: {
            type: Object,
            default: () => {
                return {};
            },
        },
        panelCfg: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
        }
    },
    computed: {
        url() {
            return this.panelCfg?.url ?? {};
        },
        acl() {
            return this.panelCfg?.acl ?? {};
        },
        actions() {
            return this.additional?.actions ?? {};
        },
        allowCreate() {
            return !!(this.actions.create && !this.form.id);
        },
        allowShow() {
            return !!(this.actions.show && this.form.id);
        },
        allowEdit() {
            return !!(this.actions.edit && this.form.id) || this.allowCreate;
        },
        allowDelete() {
            return !!(this.actions.delete && this.form.id);
        },
        allowExport() {
            return !!(this.actions.export && this.form.id);
        },
        allowViewDetail() {
            return this.actions.detail;
        },

    },
}